import MESSAGES from './Messages.graphql'
import MORE_MESSAGES from './MoreMessages.graphql'
import NEW_MESSAGE from './NewMessage.graphql'
import MESSAGE_UPDATED from './MessageUpdated.graphql'
import MESSAGE_DELETED from './MessageDeleted.graphql'
import MESSAGES_BULK_DELETED from './MessagesBulkDeleted.graphql'

export { MESSAGES, MORE_MESSAGES, NEW_MESSAGE, MESSAGE_UPDATED, MESSAGE_DELETED, MESSAGES_BULK_DELETED }

export * from './useMessages'



// WEBPACK FOOTER //
// ./src/hooks/useMessages/index.ts